import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';

@Component({
  selector: 'app-sweetalert',
  templateUrl: './sweetalert.component.html',
  styleUrls: ['./sweetalert.component.css']
})
export class SweetalertComponent implements OnInit {

  public fondo: string = '';
  public success = '#5CB85C';

  constructor() { }

  ngOnInit() {
  }

 alertaMostrarHtml(titulo: string, valorHtml:string, textoHtmlConfirmar:string, textoHtmlCancel:string,incluirBotonCancel:boolean){
	return swal.fire({
		title: titulo,
		icon: 'success',
		html:  valorHtml,
		showCloseButton: true,
		showCancelButton: incluirBotonCancel,
		focusConfirm: true,
		confirmButtonText:textoHtmlConfirmar,
	
		//confirmButtonAriaLabel: 'Thumbs up, great!',
		cancelButtonText: textoHtmlCancel,
		//cancelButtonAriaLabel: 'Thumbs down'
	})
 }

 alertaPreguntaHtml(titulo: string, valorHtml:string, textoHtmlConfirmar:string, textoHtmlCancel:string,incluirBotonCancel:boolean){
	return swal.fire({
		title: titulo,
		icon: 'question',
		html:  valorHtml,
		showCloseButton: true,
		showCancelButton: incluirBotonCancel,
		focusConfirm: true,
		confirmButtonText:textoHtmlConfirmar,
	
		//confirmButtonAriaLabel: 'Thumbs up, great!',
		cancelButtonText: textoHtmlCancel,
		//cancelButtonAriaLabel: 'Thumbs down'
	})
 }
  alertaPreguntaAbono(pregunta: string) {
	return swal.fire({
		text: pregunta,
		icon: 'question',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		confirmButtonText: 'Archivo .PDF',
		cancelButtonColor: '#d33',
		cancelButtonText: 'Archivo .txt',
		
	
	})
}

  alertaCreacion(estado: boolean, mensaje: string) {
    if (estado) {
      swal.fire('Buen trabajo!', mensaje, 'success');
    } else {
      swal.fire('Sin exito!', mensaje, 'error');
    }
  }

  alertaValidacion(estado: boolean,titulo: string, mensaje: string) {
    if (estado) {
		swal.fire({
			title: titulo, 
			text: mensaje, 
			icon: 'success',
			backdrop: 'rgba(0,20,50,0.4)'
		});
    } else {
		swal.fire({
			title: titulo, 
			text: mensaje, 
			icon: 'error',
			backdrop: 'rgba(50,10,0,0.4)'
		});
	}
  }

  alertaNotificacion(title: string, text: string, icon: string){
	const Toast = swal.mixin({
		toast: true,
		position: 'top-end',
		showConfirmButton: false,
		timer: 4000,
		onOpen: (toast) => {
		  toast.addEventListener('mouseenter', swal.stopTimer)
		  toast.addEventListener('mouseleave', swal.resumeTimer)
		}
	  });
	  
	  if (icon === 'success'){
		Toast.fire({
			icon: 'success',
			title: title,
			text: text
		})
	  } else if(icon === 'error'){
		Toast.fire({
			icon: 'error',
			title: title,
			text: text
		})
	  } else if(icon === 'info'){
		Toast.fire({
			icon: 'info',
			title: title,
			text: text
		})
	  } else if(icon === 'warning'){
		Toast.fire({
			icon: 'warning',
			title: title,
			text: text
		})
	  }
	  else if(icon === 'question'){
		Toast.fire({
			icon: 'question',
			title: title,
			text: text
		})
	  }
  }

  alertaPreguntaEliminacion() {
	 return swal.fire({
		  title: '¿Estas seguro de eliminar?',
		  text: "Recuerda, no podras revertir la eliminacion",
		  icon: 'warning',
		  showCancelButton: true,
		  confirmButtonColor: '#3085d6',
		  cancelButtonColor: '#d33',
		  confirmButtonText: 'Si, eliminar!'
	  })
  }

  alertaPreguntaAnulacion() {
	return swal.fire({
		 title: '¿Estas seguro de anular?',
		 text: "Recuerda, no podras revertir la anulación",
		 icon: 'warning',
		 showCancelButton: true,
		 confirmButtonColor: '#d33',
		 cancelButtonColor: '#3085d6',
		 confirmButtonText: '¡Si, anular!',
		 cancelButtonText: 'No anular',
		 backdrop: 'rgba(50,10,0,0.4)'
	 })
 }

  alertaEntradaTexto() {
  	return swal.fire({
		title: "Ingrese nombre de meta!",
		input: 'text',
		showCancelButton: true,
		inputPlaceholder: "Ingrese nombre"
	})
  }

  alertaEntrada(titulo, placeholder) {
  	return swal.fire({
		title: titulo,
		input: 'text',
		showCancelButton: true,
		inputPlaceholder: placeholder
	});
  }

  alertaPreguntaModificacion(pregunta: string) {
	  return swal.fire({
		title: '¿Estás seguro de modificar?',
		text: pregunta,
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: 'Si'
	  })
  }

  alertaConfirmadoEliminacion() {
	  swal.fire(
		  'Eliminado!',
		  'Bien!!! Registro eliminado con exito',
		  'success'
	  )
  }

  alertaConfirmadoModificacion(texto: string) {
	  swal.fire(
		  'Modificado!',
		  texto,
		  'success'
	  )
  }
  actualizar2(texto: string){
	swal.fire({
		text: 'Esta seguro que desea modificar?',
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: 'Si'
	})
  }

}
